import { reactive } from 'vue'
import axios from './axios'

const config = reactive({})

async function loadConfig() {
  await import(/* webpackChunkName: "chunk-intl-utils" */ 'intl-tel-input/build/js/utils')
  const response = await fetch('../config.json?id=' + Number(new Date()))
  const attrs = await response.json()

  Object.assign(config, attrs)
  axios.defaults.baseURL = `${config.APP_URL}/api`
}

export default {
  install(app) {
    app.config.globalProperties.config = config
    app.loadConfig = loadConfig
  },
}

export { config }
